import { Box, Button, Typography } from "@mui/material";
import { Video } from "lucide-react";
import { VideoRoom } from "protogen/video_pb";
import CopyButton from "components/common/CopyButton";

interface VideoCallInfoProps {
  videoRoom?: VideoRoom;
}

export default function VideoCallInfo({ videoRoom }: VideoCallInfoProps) {
  if (!videoRoom?.uuid) {
    return null;
  }

  const videoUrl = `${window.location.origin}/video/${videoRoom.uuid}`;

  const joinVideoCall = () => {
    window.open(videoUrl, "_blank");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Typography variant="h4">Meeting link</Typography>
      <Box
        sx={{ display: "flex", gap: "8px", justifyContent: "space-between" }}
      >
        <Button
          variant="contained"
          startIcon={<Video />}
          onClick={joinVideoCall}
        >
          Join video call
        </Button>
        <CopyButton value={videoUrl} variant="text" label="Copy link" />
      </Box>
    </Box>
  );
}
